import { render, staticRenderFns } from "./forgot-password-dialog.vue?vue&type=template&id=b8c568fe&scoped=true"
import script from "./forgot-password-dialog.vue?vue&type=script&lang=js"
export * from "./forgot-password-dialog.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-dialog.vue?vue&type=style&index=0&id=b8c568fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c568fe",
  null
  
)

export default component.exports